
import { obserState, obserMutations } from '@/code-lab/component/robot-connect/play-button/microstate/playState.js'
export default {
    computed: {
        inProgressIs () {
            return obserState.inProgressIs
        },
        stopOr () {
            return obserState.stopOr
        },
        buttonLock () { return obserState.buttonLock }
    },
    watch: {
        inProgressIs (val) {
            if (val > 0) {
                this._disabledAttrHd()
            } else if (val === 0) {
                console.log('unlocks')
                // setTimeout(() => {
                   
                // }, 500)
                this._disabledAttrHd(false)
                this.resetPlayStatus()
                // Object.assign(this.dialogInfoExcute, { isShow: false })
                // Object.assign(this, { loadingIs: false })
                // clearInterval(this.numTimer)
                // this.numTimer = null
                // this.num$ = 5
                // this.loadingIs = false
            }
            // if (val === 1) {
            //     console.log('export url')
            // } else if (val === 2) {
            //     console.log('send command to server')
            // } else if (val === 3) {
            //     console.log('robot handle command')
            // } else {
            //     console.log('common progress')
            // }
            console.log(val, 'inProgressIs')
        }
    },
    methods: {
        _disabledAttrHd (dis = true) {
            this.obserMutations.reset({ key: 'disabled', val: dis })
        },
        _updInProgressIs (val) {
            obserMutations.update({
                key: 'inProgressIs',
                val
            })
        }
    },
}
